import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { RfAuthenticationService } from "../rf-authentication.service";
import { environment } from "src/environments/environment";
import { CsManagementService } from "src/app/shared/service/store-management/cs-management/cs-management.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private oauthServices: RfAuthenticationService,
    private csManagementService: CsManagementService,
  ) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // TODO to remove and restore dynamic flow
    const cs_externalId = sessionStorage.getItem("cs_externalId")
      ? sessionStorage.getItem("cs_externalId")
      : "none";
    const token = this.oauthServices.getTokenId();
    const profile = JSON.parse(sessionStorage.getItem("profile"));
    const currentRole = JSON.parse(sessionStorage.getItem("profile"))
      ? +JSON.parse(sessionStorage.getItem("profile")).role
      : "none";
    const contactId = JSON.parse(sessionStorage.getItem("profile"))
      ? +JSON.parse(sessionStorage.getItem("profile")).contactId
      : "none";
    const customerId = JSON.parse(sessionStorage.getItem("profile"))
      ? +JSON.parse(sessionStorage.getItem("profile")).customerId
      : "none";
    const customerReference = !!profile ? profile.customerReference : "none";
    if (request.headers.get("skip")) {
      return next.handle(request);
    }
    
    if (token && !request.url.includes("oauth2/")) {
      request = request.clone({
        setHeaders: {
          contactId: JSON.stringify(contactId),
          customerId: JSON.stringify(customerId),
          currentRole: JSON.stringify(currentRole),
          customerReference,
          "cs-externalId": cs_externalId,
          Authorization: `Bearer ${token}`,
          // "Access-Control-Allow-Origin": "*",
          "Ocp-Apim-Subscription-Key": environment.OcpApimSubscriptionKey,
          "x-ald-subscription-key": environment.xAldSubscriptionKey,
          "VulContactId": profile != null ? profile.contactId : "",
          "VulRuolo": this.getRole(profile),
          "VulSlReference": this.getSLRef(profile),
        },
      });
    } else {
      this.oauthServices.getTokenId();
    }
    return next.handle(request);
  }

  getSLRef(profile: any) {
    if (profile) {
      return profile.sl_reference ?? "";
    }
    return "";
  }

  getRole(profile: any) {
    if (profile) {
      switch (profile.role) {

        case "2":
        case "400028":
        case "400035":
        case "400031":

          return "fleetmanager";

        case "1":
        case "3":
        case "8":
        case "9":
        case "400023":
          return "driver";


        case "10":
        case "400008":
        case "400009":
        case "17":
        case "400034":
          return "sales";

        case "11":
          return "broker";

        default:
          return "none";

      }
    }
    else {
      return "none";
    }
  }
}
